import { useConfirm } from "./useConfirm";

/**
 * Vue плагин для глобального $confirm
 * Заменяет ElMessageBox.confirm на shadcn AlertDialog
 *
 * Установка: app.use(ConfirmPlugin)
 *
 * Использование в Options API: this.$confirm(message, title, options)
 * Использование в Composition API: const confirm = useConfirm()
 */
export const ConfirmPlugin = {
  install(app) {
    const confirm = useConfirm();
    app.config.globalProperties.$confirm = confirm;
  },
};
